'use strict';
// TODO: Remove from `core-js@4`
require('../modules/es.set.intersection.v2');



//////////////////
// WEBPACK FOOTER
// ./~/core-js/modules/esnext.set.intersection.v2.js
// module id = 1500
// module chunks = 0